import React, {Component} from 'react';
import SearchingTitleComponent from './SearchingTitleComponent';
import ReactDOM from 'react-dom';
import { Badge, Col, Row } from 'reactstrap';
import { GeMap_SPECIAL_ACTION, GeMap_With_Key_SPECIAL_ACTION, GetListAttempt_ACTION, GetMultipleListAttempt_ACTION, UpdateMap_LS_ACTION } from '../Actions/LogisticActions';
import {connect} from 'react-redux'
import { Routes } from '../Services/API';
import ModalComponent from './ModalComponent';
import ImageTreeNode from './ImageTreeNode';
import {Rectangle, Circle, Ellipse, Line, Polyline, CornerBox, Triangle} from 'react-shapes';
import Slider from '@material-ui/core/Slider';
import NameComponent from './NameComponent';
import { WEBSITE_URL } from '../Services/Utilities';
import QuestionSeriesPlayinMap from '../views/Questions/QuestionSeriesPlayinMap';
import Xarrow from "react-xarrows";

var FinalElementImage = require('../Sources/goal-icon.png')

class PlayGeneralMapWithKey extends Component {
    constructor(props){
        super(props)

        this.state = {
            
        }


        this.ElementModal = this.ElementModal.bind(this)
    }

    componentDidMount(){
        //this.props.GetMap(this.props.match.params.id)
        this.props.GetMap(this.props.Id)
    }

    
    render(){
        console.log(this)
        return(
            <div>
                {this.ElementModal()}
               {(this.props.IsSearching  || this.props.IsSearching == undefined || this.props.GetError || this.props.GetError == undefined) ? 
                      <SearchingTitleComponent error = {this.props.GetError}/>
                  :
                  (!this.state.PlaySeries ? <Row>
                  <Col xs = {10}>
                      <div>
                      <img 
                        src = {this.props.Map.LargeMapURL}
                        style = {{width: window.innerWidth * 0.7, height: (this.props.Map.LargeMapLength/this.props.Map.LargeMapWidth) * window.innerWidth * 0.7}}
                        ref = {'Image_Div'}
                        onLoad = {() => {
                            let node = ReactDOM.findDOMNode(this.refs['Image_Div']).parentNode.parentNode
                            let nodeStyle = window.getComputedStyle(node)
                            let padding = nodeStyle.getPropertyValue('padding')
                            let Offset = parseInt(padding.substring(4,6))
                            this.setState({
                                Offset:Offset
                            })
                        }}
                      
                      />
                      {this.props.Map.Elements.map((e,i) => 
                       <span className={this.props.Map.ShowBorder ? "border border-primary" : ""} 
                       key = {i}
                       ref = {'REF_ELEMENT_' + e.Title}    
                        id = {'REF_ID_' + e.Title}
                       style = {{
                         position: 'absolute',
                         cursor:'pointer',
                         width: e.Width*((window.innerWidth * 0.7)/this.props.Map.LargeMapWidth),
                         height: e.Length*(((this.props.Map.LargeMapLength/this.props.Map.LargeMapWidth) * window.innerWidth * 0.7)/this.props.Map.LargeMapLength),
                         left:  (e.X - this.state.Offset/2)*((window.innerWidth * 0.7)/this.props.Map.LargeMapWidth),
                         top:  (e.Y)*(((this.props.Map.LargeMapLength/this.props.Map.LargeMapWidth) * window.innerWidth * 0.7)/this.props.Map.LargeMapLength)
                       }}

                       onClick = {() => {
                            this.setState({
                                SelectedElement: e,
                                ShowElementModal: true
                            })
                       }}
                     >
                         {!(e.Badge_X || e.Badge_Y) && e.Badges.length && e.QuestionSeries && this.props.Map.LS.DataExists? 
                            <div>
                                {e.LS_Answer &&
                             (e.Badges.filter((b) => 
                                 {
                                    return (b.Progress <= 100 *(e.QuestionSeries.Elements.filter((eL) => e.LS_Answer.Progress.map(p => p.Id).includes((eL.QuestionId))).length/(e.QuestionSeries.IsRandom ? e.QuestionSeries.RandomSize : e.QuestionSeries.Elements.length)))
                                }).length)
                             ?
                                <div>
                                    <img 
                                        src = {e.Badges.filter((b) => {
                                            
                                            return (b.Progress <= 100 *(e.QuestionSeries.Elements.filter((eL) => e.LS_Answer.Progress.map(p => p.Id).includes((eL.QuestionId ))).length/(e.QuestionSeries.IsRandom ? e.QuestionSeries.RandomSize : e.QuestionSeries.Elements.length)))
                                            
                                        }).sort((a,b) => a.Progress > b.Progress ? -1 : +1)[0].URL
                                    }

                                        style = {{
                                            width: '50%',
                                            height:'50%'
                                        }}
                                    />
                                </div>
                             :
                             <div/>
                            }
                         </div>
                        
                        : <div/>}
                        {this.props.ShowSolutionPath ? 
                                      <div>
                                        {e.IsFinal ? <img
                                            style = {{
                                                width: '100%',
                                                height: '100%',
                                                
                                            }}
                                           
                                            src = {FinalElementImage}
                                            
                                            /> : <div/>}
                                      </div>
                                      
                                      : <div/>}
                        
                     </span>)}
                     {this.props.Map.Elements.filter(e => (e.Badge_X && e.Badge_Y)  && !this.props.ShowSolutionPath).map((e,i) => 
                       <span className={this.props.Map.ShowBorder ? "border border-success" : ""} key = {i}
                       style = {{
                         position: 'absolute',
                         width: e.Badge_Width*((window.innerWidth * 0.7)/this.props.Map.LargeMapWidth),
                         height: e.Badge_Length*(((this.props.Map.LargeMapLength/this.props.Map.LargeMapWidth) * window.innerWidth * 0.7)/this.props.Map.LargeMapLength),
                         left:  (e.Badge_X - this.state.Offset/2)*((window.innerWidth * 0.7)/this.props.Map.LargeMapWidth),
                         top:  (e.Badge_Y)*(((this.props.Map.LargeMapLength/this.props.Map.LargeMapWidth) * window.innerWidth * 0.7)/this.props.Map.LargeMapLength)
                       }}

                      
                     >
                         { e.Badges.length && e.QuestionSeries && this.props.Map.LS.DataExists? 
                            <div>
                                {e.LS_Answer &&
                             (e.Badges.filter((b) => 
                                 {
                                    /*console.log('****')
                                    console.log(badge)
                                    console.log(badge.Progress <= 100 *(e.QuestionSeries.Elements.filter((eL) => e.LS_Answer.Progress.map(p => p.Id).includes((eL.ClickableQuestionId ||  eL.KeyboardQuestionId))).length/e.QuestionSeries.Elements.length))
                                    console.log(badge.Progress )
                                    console.log(e.LS_Answer.Progress)
                                    console.log(100 *(e.QuestionSeries.Elements.filter((eL) => e.LS_Answer.Progress.map(p => p.Id).includes((eL.ClickableQuestionId ||  eL.KeyboardQuestionId))).length/e.QuestionSeries.Elements.length))
                                    
                                    console.log('****')*/

                                    return (b.Progress <= 100 *(e.QuestionSeries.Elements.filter((eL) => e.LS_Answer.Progress.map(p => p.Id).includes((eL.QuestionId ))).length/(e.QuestionSeries.IsRandom ? e.QuestionSeries.RandomSize : e.QuestionSeries.Elements.length)))
                                }).length)
                             ?
                                <div>
                                    <img 
                                        src = {e.Badges.filter((b) => {
                                            
                                            return (b.Progress <= 100 *(e.QuestionSeries.Elements.filter((eL) => e.LS_Answer.Progress.map(p => p.Id).includes((eL.QuestionId ))).length/(e.QuestionSeries.IsRandom ? e.QuestionSeries.RandomSize : e.QuestionSeries.Elements.length)))
                                            
                                        }).sort((a,b) => a.Progress > b.Progress ? -1 : +1)[0].URL
                                    }

                                        style = {{
                                            width: '100%',
                                            height:'100%'
                                        }}
                                    />
                                </div>
                             :
                             <div/>
                            }
                         </div>
                        
                        : <div/>}   
                     </span>)}
                     {this.props.ShowSolutionPath ? 
                              this.props.Map.Elements
                              .sort((a,b) => a.Id > b.Id ? 1 : -1)
                              .map((e,i) => (
                                  <div key = {i}>
                                      {e.RequiredElement ? 
                                       <div
                                       style = {{
                                        width: e.Width, height: e.Length,
                                       left:e.X, top: e.Y,
                                       position:'absolute',
                                           flexDirection:'column', alignContent:'center', alignItems:'center'
                                       }}
                                       >
                                           <Xarrow
                                       start={'REF_ID_' + e.RequiredElement.Title} 
                                       end={'REF_ID_' + e.Title} 
                                       strokeWidth={2}
                                       headSize={5}
                                       startAnchor="auto"
                                       endAnchor="auto"
                                       color={(()=> {
                                           let Color = "green"
                                           let HasFinal = false
                                            let ReqElements = []
                                            let Current = e

                                            while(Current){
                                                if(Current.HasFinal){
                                                    HasFinal = true
                                                    break
                                                }
                                                
                                                ReqElements.push(e.RequiredElement)
                                                Current = Current.RequiredElement
                                                
                                            }

                                            if(HasFinal){
                                                Color = "red"
                                            }


                                           return Color
                                       })()}
                                       path={"straight"}
                                     />
                                       </div> : <div/>}
                                  </div>
                              )) : <div/>} 
                      </div>
                  </Col>
                  <Col xs = {2} style = {{position:'fixed', marginLeft: window.innerWidth*0.7 + 5, marginTop:20}}>
                      {this.state.SelectedElement && false ? 
                      <div className = "border border-success" style = {{width:'90%'}}>
                          <Row>
                              <Col xs = {12}>
                                <NameComponent text = {this.state.SelectedElement.Title} textColor = "green"/>
                              </Col>
                          </Row>
                          <hr/>
                         {this.state.SelectedElement.ExternalVideoLink ?
                          <Row style = {{cursor:'pointer'}}
                          onClick = {() => {
                              window.open(this.state.SelectedElement.ExternalVideoLink)
                          }}>
                              <Col xs = {2} >
                                <h4>
                                    <Badge color = "primary">
                                    External link
                                    </Badge>
                                </h4>
                              </Col>
                              <Col xs = {1}></Col>
                              <Col xs = {9} 
                              >
                                  <p className = "text text-primary">
                                    {this.state.SelectedElement.ExternalVideoLink}
                                  </p>
                              </Col>
                          </Row> : <div/>}
                          
                          {this.state.SelectedElement.QuestionSeries ?
                          <Row style = {{marginTop:20,cursor:'pointer'}}
                          onClick = {() => {
                            let URL = WEBSITE_URL + '/Questions/QuestionSeriesPlay/' + this.state.SelectedElement.QuestionSeries.Code
                            window.open(URL)
                          }}>
                          <Col xs = {2}>
                            <h4>
                                <Badge color = "success">
                                Question Series
                                </Badge>
                            </h4>
                          </Col>
                          <Col xs = {1}></Col>
                          <Col xs = {9} 
                          >
                              <p style = {{color:'#008000'}}>
                                {this.state.SelectedElement.QuestionSeries.Code}
                              </p>
                          </Col>
                      </Row> : <div/>}
                      
                          <Row style = {{marginTop:20}}>
                          {this.state.SelectedElement.PDFURL ? <Col xs = {1} >
                            <h4>
                                <Badge color = "danger" style = {{cursor:'pointer'}} onClick = {() => {
                            window.open(this.state.SelectedElement.PDFURL)
                          }}>
                                PDF
                                </Badge>
                            </h4>
                          </Col>: <div/>}
                          <Col xs = {1}/>
                          {this.state.SelectedElement.VideoURL ?<Col xs = {1} >
                                <h4>
                                    <Badge color = "primary" style = {{cursor:'pointer'}}
                          onClick = {() => {
                              window.open(this.state.SelectedElement.VideoURL)
                          }}>
                                    Video
                                    </Badge>
                                </h4>
                              </Col> : <div/>}
                              
                              
                          </Row>
                      
                          
                      </div> 
                      : <div/>}
                  </Col>
              </Row>: 
                <QuestionSeriesPlayinMap 
                          Code = {this.state.SelectedElement.QuestionSeries.Code}
                          Object = {this}
                          ObjectId = {this.props.Map.Id}
                          ElementId={this.state.SelectedElement.Id}
                          Key = {this.props.Key}
                />)}
            </div>
        )
    }

    ElementModal(){
        if(!this.state.ShowElementModal){
            return
        }

        let Element = this.state.SelectedElement
        let RElement = this.state.SelectedElement.RequiredElement
        let RMElement = undefined 

        if(RElement){
            RMElement = this.props.Map.Elements.filter((e) => e.Id == RElement.Id)[0]

            console.log('RElement')
            console.log(RElement)

            console.log(RMElement)
            console.log((!RElement || !RElement.QuestionSeries ||
                (RMElement.LS_Answer 
                    && 
                
                (Element.Threshold 
                < 
                100 * RMElement.QuestionSeries.Elements.filter((eL) => RMElement.LS_Answer.Progress.map(p => p.Id).includes((eL.QuestionId ))).length/(RMElement.QuestionSeries.IsRandom ? RMElement.QuestionSeries.RandomSize : RMElement.QuestionSeries.Elements.length))
               

                )))

        }

        return(
            <ModalComponent isOpen = {this.state.ShowElementModal} size = "xl">
            <Row>
                <Col xs = {11}> 
                <NameComponent text = {this.state.SelectedElement.Title}/>
                </Col>
            </Row>
            {((!RElement || !RElement.QuestionSeries ||
                (RMElement.LS_Answer 
                    && 
                
                (Element.Threshold 
                < 
                100 * RMElement.QuestionSeries.Elements.filter((eL) => RMElement.LS_Answer.Progress.map(p => p.Id).includes((eL.QuestionId))).length/(RMElement.QuestionSeries.IsRandom ? RMElement.QuestionSeries.RandomSize : RMElement.QuestionSeries.Elements.length))
               

                ))) ? <div>
            <hr/>
                         {this.state.SelectedElement.ExternalVideoLink ?
                          <Row style = {{cursor:'pointer'}}
                          onClick = {() => {
                              window.open(this.state.SelectedElement.ExternalVideoLink)
                          }}>
                              <Col xs = {2} >
                                <h4>
                                    <Badge color = "primary">
                                    External link
                                    </Badge>
                                </h4>
                              </Col>
                              <Col xs = {1}></Col>
                              <Col xs = {9} 
                              >
                                  <p className = "text text-primary">
                                    {this.state.SelectedElement.ExternalVideoLink}
                                  </p>
                              </Col>
                          </Row> : <div/>}
                          
                          {this.state.SelectedElement.QuestionSeries ?
                          <Row style = {{marginTop:20,cursor:'pointer'}}
                          onClick = {() => {
                            this.setState({
                                PlaySeries: true,
                                ShowElementModal: false
                            })
                          }}>
                          <Col xs = {2}>
                            <h4>
                                <Badge color = "success">
                                Question Series
                                </Badge>
                            </h4>
                          </Col>
                          <Col xs = {1}></Col>
                          <Col xs = {9} 
                          >
                              <p style = {{color:'#008000'}}>
                                {this.state.SelectedElement.QuestionSeries.Code}
                              </p>
                          </Col>
                      </Row> : <div/>}
                      
                          <Row style = {{marginTop:20}}>
                          {this.state.SelectedElement.PDFURL ? <Col xs = {1} >
                            <h4>
                                <Badge color = "danger" style = {{cursor:'pointer'}} onClick = {() => {
                            window.open(this.state.SelectedElement.PDFURL)
                          }}>
                                PDF
                                </Badge>
                            </h4>
                          </Col>: <div/>}
                          {this.state.SelectedElement.VideoURL ?<Col xs = {1} >
                                <h4>
                                    <Badge color = "primary" style = {{cursor:'pointer'}}
                          onClick = {() => {
                              window.open(this.state.SelectedElement.VideoURL)
                          }}>
                                    Video
                                    </Badge>
                                </h4>
                              </Col> : <div/>}
                              
                              
                          </Row>
            </div> : 
            <div className = "border border-success" style = {{marginTop:20, cursor:'pointer'}} onClick = {() =>{
                this.setState({
                    SelectedElement: RMElement
                })
            }}>
                <NameComponent text = {"Please Solve Question Series in Element (" + RElement.Title + ") Up to " + Element.Threshold + "% Success"}/>
                          <br/>
                <NameComponent text = {"Click to Go to Element (" + RElement.Title + ")"}/>

            </div>
                }
            <hr/>
            <Row>
                <Col xs = {10}></Col>
                <Col xs = {1}>
                    <h4>
                        <Badge color = "danger" style = {{cursor:'pointer'}} 
                        onClick = {() => {
                            this.setState({
                                ShowElementModal: false
                            })
                        }}
                        >
                            Close
                        </Badge>
                    </h4>
                </Col>
            </Row>
            </ModalComponent>
        )
    }

    
}
//Constant

const COURSE_MAP_SEARCHING_PARAMETER = 'IsCourseMapSearching'
const COURSE_MAP_DATA_PARAMETER = 'CourseMap'
const COURSE_MAP_GET_ERROR_PARAMETER = 'CourseMapGetError'
//LOCAL STORAGE
export const LS_WITH_KEY_MAP = 'LS_MAP_12162020_WITH_KEY'
export const LS_MAP_KEY = 'LS_MAP_KEY_12162021_WITH_KEY'

function MapStateToProps(state) {
    return {
        IsSearching: state.Query[COURSE_MAP_SEARCHING_PARAMETER],
        Map: state.Query[COURSE_MAP_DATA_PARAMETER],
        GetError: state.Query[COURSE_MAP_GET_ERROR_PARAMETER],
        Name: state.Authorization.name,
        
    }
  }
  
  const MapDispatchToProps = (dispatch) => {
    return {
        GetMap: (Id) => {dispatch(GeMap_With_Key_SPECIAL_ACTION({
            SearchParameter: COURSE_MAP_SEARCHING_PARAMETER,
            DataParameter: COURSE_MAP_DATA_PARAMETER,
            GetErrorParameter: COURSE_MAP_GET_ERROR_PARAMETER,
            Path: Routes.GetCourseMapPlayById,
            Value: Id,
    
            [COURSE_MAP_SEARCHING_PARAMETER]: true,
            
            [COURSE_MAP_DATA_PARAMETER]: [],
    
            [COURSE_MAP_GET_ERROR_PARAMETER]: '',
        }))},
        UpdateProgress: (Data) => {dispatch(UpdateMap_LS_ACTION({
           
            Key: LS_WITH_KEY_MAP + Data.MapId,
            Data: Data,
    
           
        }))},
  }
}
  
export default connect(MapStateToProps, MapDispatchToProps)(PlayGeneralMapWithKey)